import * as React from "react";

function SvgLamp() {
  return (
    <svg
        className="lamp meuble"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 254.1 476.62"
    >
      <defs>
        <radialGradient
          id="lamp_svg__D\xE9grad\xE9_sans_nom_55"
          cx={485.29}
          cy={1690.29}
          r={268.74}
          gradientTransform="matrix(.41 0 0 .37 -74.05 -512.96)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#f18439" />
          <stop offset={0.1} stopColor="#eb8138" stopOpacity={0.98} />
          <stop offset={0.23} stopColor="#db7834" stopOpacity={0.91} />
          <stop offset={0.37} stopColor="#c16a2e" stopOpacity={0.8} />
          <stop offset={0.53} stopColor="#9c5525" stopOpacity={0.64} />
          <stop offset={0.7} stopColor="#6c3b1a" stopOpacity={0.45} />
          <stop offset={0.87} stopColor="#331c0d" stopOpacity={0.21} />
          <stop offset={1} stopColor="#010101" stopOpacity={0} />
        </radialGradient>
        <style />
      </defs>
      <g data-name="Calque 2">
        <g id="lamp_svg__BABY_ROOM" data-name="BABY ROOM">
          <path
            className="lamp_svg__cls-2"
            d="M136.62 466.23l-1-.21V141.23h40.47l5.88-57.83H88.56l5.88 57.83h38.83V466l-41.45 10.62h94.07l-49.27-10.39z"
          />
          <path
            id="chaine_ombre"
            className="lamp_svg__cls-2"
            d="M154.41 173.12v-44.15h-.83v44.15h-1.16v8.83h3v-8.83h-1.01z"
          />
          <path
            id="chaine"
            className="lamp_svg__cls-3"
            d="M144.41 173.12v-44.15h-.83v44.15h-1.16v8.83h3v-8.83h-1.01z"
          />
          <path
            className="lamp_svg__cls-3"
            d="M124.28 465.74l-42.46 10.88h94.07l-51.61-10.88z"
          />
          <path
            className="lamp_svg__cls-3"
            d="M123.27 127.44h2.35v345.19h-2.35z"
          />
          <path
            className="lamp_svg__cls-5"
            fill="#6b87b1"
            d="M171.97 83.4H78.56l5.88 57.83h81.65l5.88-57.83z"
          />
          <path
            className="lamp_svg__cls-6"
            fill="#57628d"
            opacity={0.3}
            d="M136.41 83.4H87.39l8.58 57.83h37.36l3.08-57.83z"
          />
          <ellipse
            className="lamp_svg__cls-8"
            cx={127.05}
            cy={113.63}
            rx={127.05}
            ry={113.63}
            style={{
              mixBlendMode: "screen",
            }}
            fill="url(#lamp_svg__D\xE9grad\xE9_sans_nom_55)"
          />
        </g>
      </g>
    </svg>
  );
}

export default SvgLamp;
